import axios from "axios";

export default class axiosClient {
  async getWithdrawalRequests(params) {
    const headers = {
      accept: "application/ld+json",
      "Content-Type": "application/ld+json"
    };
    const resp = await axios.get("/api/token_events", {
      headers: headers,
      params: params
    });
    const data = resp.data["hydra:member"];
    const totalItems = resp.data["hydra:totalItems"];
    return { data, totalItems };
  }

  async sendMailConfirmation(id) {
    return await axios.get(`/api/users/send_mail_confirmation_code/${id}`);
  }

  async confirmMailCode(params) {
    return await axios.post("/api/users/confirm_2fa_code", params);
  }
}
